"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.polarToCartesian = void 0;
const polarToCartesian = (centerX, centerY, radius, angle, delta = Math.PI / 2, isInDegrees = false) => {
    if (isInDegrees) {
        angle = (angle * Math.PI) / 180.0;
    }
    angle += delta;
    return {
        x: centerX + radius * Math.cos(angle),
        y: centerY + radius * Math.sin(angle),
    };
};
exports.polarToCartesian = polarToCartesian;
//# sourceMappingURL=polarToCartesian.js.map